module.exports = new __parcel__URL__("kick_button_disabled.4d1c8689.png").toString();